import React, { FC } from 'react';
import './style.scss';
import classNames from 'classnames';

interface IDots {
  currentSlider: number
}

const CustomDots: FC<IDots> = (props) => {
  const numberDot = [0, 1, 2];
  return (
    <ul className="dots">
      {
        numberDot.map((item: number) => {
          return (
            <li key={item} className={classNames({
              'dot': true,
              'dot--active': item === props.currentSlider
            })} />
          )
        })
      }
    </ul>  
  )
};

export default CustomDots;
